import { Image, makeStyles, useToastController } from "@fluentui/react-components";
import * as React from "react";
import { login } from "../../utils/auth";
import { notify } from "../components/Toast";
import { centered, colors, useTextStyles } from "../styles";

const useStyles = makeStyles({
  loginButton: {
    ...centered,
    gap: "10px",
    backgroundColor: colors.primaryButtonBackground,
    cursor: "pointer",
    border: "unset",
    borderRadius: "5px",
    boxShadow: "lightgrey 0px 2px 5px",
    padding: "5px 20px",
    marginTop: "50px"
  }
});

const Login: React.FC = () => {
  const styles = useStyles();
  const textStyles = useTextStyles();

  const { dispatchToast } = useToastController();

  return (
    <div style={{ ...centered, flexDirection: "column", textAlign: "center" }}>
      <Image style={centered} width="250" height="200" src="https://fundwave.com/assets/img/FundwaveFunctionsLogin.png" alt={"Login"} />
      <div
        onClick={() => {
          dispatchToast(notify("Signing in..."), { intent: "info", timeout: 5000, position: "bottom" });
          login();
        }}
        className={styles.loginButton}
      >
        <Image width="30" height="30" src="https://fundwave.com/assets/img/logo-blue-ribbon-wave.png" />
        <span className={textStyles.btnText}>Sign in with Fundwave</span>
      </div>
    </div>
  );
};

export default Login;
